import React from 'react'
import { useTranslation } from 'react-i18next'
import { EmptyTableStyled } from '../OverallDomainPreformance.styled'
import { ComponentLoader } from '@clickcease/cc-client-components-lib'
import { LoaderWrapper } from '../DomainsTable.styled'

type Props = {
  isActiveTable: boolean
  isLoading?: boolean
}
export const EmptyTable = (props: Props) => {
  const { t } = useTranslation('home')
  const translation = props.isActiveTable ? 'no_active_domains' : 'no_pending_domains'
  return (
    <EmptyTableStyled>
      {props.isLoading ? (
        <LoaderWrapper css={{ height: '300px' }}>
          <ComponentLoader css={{ position: 'relative' }} />
        </LoaderWrapper>
      ) : (
        t(translation)
      )}
    </EmptyTableStyled>
  )
}
